import { getImage } from '../../../../utils/imageHelper';
import styles from "../../cards.module.scss"

function NewsItem({ news, handleClickNews, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickNews}>
      <img
        className={styles.projectImage}
        src={news.image ? news.image.file : getImage('img-ph.png')}
        alt={news.image ? news.image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{news.title}</p>
        </div>
      </div>
    </div >
  );
}

export default NewsItem;
